<ng-container *transloco="let t" class="container">
  <app-admin-modal-layout
          [title]="title ?? ''"
          [saveLabel]="confirmButtonTitle ?? t('app.common.confirm')"
          [cancelLabel]="dismissButtonTitle ?? t('app.common.cancel')"
          (onSave)="onConfirmClick()"
          (onClose)="onDismissClick()"
          [saveDisabled]="!isAnyRaceSelected() && raceStartDateType !== RaceStartDateType.EDIT"
  >
    @if (raceStartDateType === RaceStartDateType.START) {
    <div class="pb-4">
      <input type="checkbox" class="form-check-input border-2 me-2" id="startOnlyRdy" [(ngModel)]="startOnlyRdy"/>
      <label class="form-check-label" for="startOnlyRdy">{{ t("measurements.start.only.rdy") }}</label>
        </div>
    }
    <table class="w-100">
      <thead class="admin-modal-table-underline">
      <tr>
        <th class="py-6">{{ t('measurements.race.name') }}</th>
        <th class="py-6">{{ t('measurements.race.start.by.gender') }}</th>
        <th class="py-6">{{ t('competitor.table.startBlock') }}</th>
        <th class="py-6">{{ t('measurements.race.started') }}</th>
        <th class="py-6"></th>
      </tr>
      </thead>
      <tbody>
      @for (race of listOfRaces; track race; let outerIdx = $index) {
      @for (raceStartItem of race.raceStartItems; track raceStartItem; let idx = $index) {
      <tr class="admin-modal-table-underline">
        @if (idx === 0) {
        <td [rowSpan]="race.raceStartItems?.length" class="py-6 limited-width">
          <app-language-output [hrLabel]="race.name"
                               [enLabel]="race.nameEng"
                               [itLabel]="race.nameIta"
                               [siLabel]="race.nameSlo"
                               [srLabel]="race.nameSr"
                               [bsLabel]="race.nameBs"
                               [languages]="languages"/>
        </td>
        }
        <td class="py-6">@if (raceStartItem.type === RaceStartType.MAN) {
          {{ t('measurements.race.start.by.gender.man') }}
          } @else if (raceStartItem.type ===
          RaceStartType.WOMAN) {
          {{ t('measurements.race.start.by.gender.woman') }}
          } @else {
          {{ '-' }}
          }
        </td>
        <td class="py-6">{{ raceStartItem.blockNumber ? raceStartItem.blockNumber : '-' }}</td>
        <td class="py-6">{{
          raceStartItem.started ? (raceStartItem.started | localizedDate:'dd.MM.yyyy HH:mm:ss.SSS') : '-'
          }}
        </td>
        <td class="py-6">
          @if (RaceStartDateType.START === raceStartDateType) {
          @if(Race.isChronometerRace(race!.startEvery)) {
          &nbsp;
          } @else {
          <input type="checkbox" [disabled]="!!raceStartItem.started" class="form-check-input border-2"
                 [(ngModel)]="raceStartItem.selected"/>
          }
          } @else if (RaceStartDateType.EDIT === raceStartDateType) {
          @if(Race.isChronometerRace(race!.startEvery)) {
          &nbsp;
          } @else {
          <input type="radio" class="form-check-input" [value]="outerIdx + '-' + idx"
                 [disabled]="!raceStartItem.started || Race.isChronometerRace(race!.startEvery)"
                 [(ngModel)]="selectedRadioButton"
                 (click)="onSelect(raceStartItem)"/>
          }
          } @else {
          <input type="checkbox" [disabled]="!raceStartItem.started"
                 class="form-check-input border-2"
                 [(ngModel)]="raceStartItem.selected"/>
          }
        </td>
      </tr>
      }
      }
      </tbody>
    </table>
    @if (raceStartDateType === RaceStartDateType.EDIT) {
    <form [formGroup]="inputForm">
      <div class="pt-3 d-flex align-items-center flex-column">
        <div class="row g-2 w-100 justify-content-center pb-2">
          <div class="col-5">
            <app-date-time-input formControlName="time" [displayTime]="true" [displaySeconds]="true"
                                 [displayMilliseconds]="true" [label]="t('measurements.time')"/>
          </div>
        </div>
      </div>
    </form>
    }
  </app-admin-modal-layout>
</ng-container>
